// extracted by mini-css-extract-plugin
module.exports = {"active":"SuccessfulAdd_active__2C0QZ"};